import { getData, postData, putData, deleteAuthorizationHeader } from './network.service';
import { deleteCookie } from './cookies.service';
import accountNotificationsService from '../../accountNotifications/data/accountNotifications.service';
import { envUrls } from '../../../constants';
import { prepareTemplatesForMaxDiff } from './utils';
import walkmeModule from '../../walkme/walkme.module';

const apiUrls = {
    getDashboardData: 'solutions/homepage/dashboard/information',
    getHeaderData: 'contentProvider/GetHeaderInitialData',
    logOut: 'Authorization/Logout',
    clientSwitchContext: 'Authorization/ChangeClientContext',
    initializeWalkmeCookies: 'Authorization/InitializeWalkmeCookies',
};

export const getInitialData = (baseUrl: string, callback: (data: any) => void, onError: (error?: any) => void) => {
    return getData(
        `${baseUrl}${apiUrls.getHeaderData}`,
        data => {
            // Move all MaxDiff templates modifications to a separate function
            callback?.(prepareTemplatesForMaxDiff(data));
        },
        onError
    );
};

export const getSolutionsData = async (
    baseUrl: string,
    callback: (data: any) => void,
    onError: (error?: any) => void
) => {
    return getData(`${baseUrl}/${apiUrls.getDashboardData}`, callback, onError);
};

export const logout = (
    baseUrl: string,
    callback: (response: XMLHttpRequestResponseType) => void,
    onError: (response: XMLHttpRequestResponseType) => void
) => {
    return putData(`${baseUrl}${apiUrls.logOut}`, callback, onError);
};

export const logoutAndRedirect = async (options: LogoutOptions, callback?: () => void) => {
    const baseUrl = options.baseUrl || envUrls.TRN;
    logout(
        baseUrl,
        () => {
            deleteCookie('AuthToken', options.cookieDomain);
            deleteAuthorizationHeader();
            walkmeModule.destroy();
            accountNotificationsService.clearAccountCookies();
            callback?.();
        },
        () => {}
    );
};

export const clientSwitchContext = (
    baseUrl: string,
    callback: (response: any) => void,
    onError: (response: XMLHttpRequestResponseType) => void
) => {
    return getData(`${baseUrl}${apiUrls.clientSwitchContext}`, callback, onError);
};

export const initializeWalkmeCookies = (
    baseUrl: string,
    data: any,
    callback: (data: any) => void,
    onError: (error?: any) => void
) => {
    return postData(`${baseUrl}${apiUrls.initializeWalkmeCookies}`, data, callback, onError);
};

export type LogoutOptions = {
    baseUrl: string;
    cookieDomain: string;
};
